import { Button, Drawer, Row, Col, Modal, Form, notification } from 'antd';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { COLOR, FONT } from './constants';
import {
  CloseOutlined
} from '@ant-design/icons';

import * as Service from './core/Service';
import styled from 'styled-components'
import WhitelistForm from './components/WhitelistForm';
import useResponsive from './hooks/useResponsive';


const WhitelistModal = ({ visible, setVisible, formSuccess, setFormSuccess }) => {
  const { isMobile } = useResponsive()
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true)
    const resp = await Service.call('post', '/api/whitelist', values);
    setLoading(false)

    if (!resp) {
      return notification.error({ message: 'Network Error', duration: 0 })
    }

    if (resp.status <= 0) {
      return notification.error({ message: resp.errorMessage, duration: 0 })
    }

    form.resetFields();
    setFormSuccess(true)
  }


  return (
    <>
      <Modal
        centered
        destroyOnClose
        width={isMobile ? '95vw' : '50vw'}
        maskClosable={false}
        bodyStyle={{ width: '100%', padding: 32, background: COLOR.secondary, minHeight: 100 }}
        footer={null}
        onCancel={() => {
          setVisible(false);
          setFormSuccess(false)
        }}
        visible={visible}
      >
        {formSuccess ?
          <Row align='middle' justify='center' style={{ minHeight: 100 }}>
            <Col span={24} style={{ ...FONT.text, marginTop: 20 }}>
              We've received your submission and will transfer a whitelist token to your wallet soon. Please email us at <span style={{ ...FONT.captionText }}>nineblocks@technine.io</span> if any enquiries.
            </Col>
          </Row>
          :
          <Row gutter={[0, 24]}>
            <Col span={24} style={{ ...FONT.h5, background: COLOR.secondary, }}>Whitelist Form</Col>
            <Col span={24}>
              <WhitelistForm onFinish={onFinish} form={form} loading={loading} />
            </Col>
          </Row>
        }

      </Modal>
    </>
  );
};

export default WhitelistModal;